import {AlivePayload, GeneralAction} from "../../@types/actions";
import {SET_ALIVE} from "../../constants/CommonConstants";

export const SetAliveAction = (data: AlivePayload): GeneralAction<AlivePayload> => ({
    type: SET_ALIVE,
    payload: data
});
